export { GraphiQLProvider } from '@graphiql/react';
export { GraphiQLInterface, GraphiQL, GraphiQL as default, } from './components/GraphiQL';
//# sourceMappingURL=index.js.map